import axios from "axios";
import { baseUrl3, config, requestID, getUser } from "../../common/utils";

const API_PREFIX = `${baseUrl3()}campaigns/`;

export const getCampaignsBeneficiary = async (campaignId) => {
  try {
    const res = await axios.post(
      baseUrl3() + `Analytics/getCampaignsBeneficiary`,
      {
        requestID: requestID(),
        campaign_id: campaignId,
      },
      config
    );
    console.log("getCampaigns response:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign vendors:", error);
    throw error;
  }
};


export const getCampaignsVendorsReport = async (campaignId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getCampaignsVendorsReport1',
      {
        requestID: requestID(),
        campaign_id: campaignId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching vendors report:', error);
    throw error;
  }
};

export const getVendorCampaignFullPaymentsReport = async (campaignId: string, vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'analytics/getVendorCampaignFullPaymentsReport1',
      {
        requestID: requestID(),
        campaign_id: campaignId,
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching vendor payment details:', error);
    throw error;
  }
};


export const getAllVendorsReport = async () => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getAllVendorsReport1',
      {
        requestID: requestID()
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching vendors:', error);
    throw error;
  }
};

export const getVendorBusinessesProductsReport = async (vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getVendorBusinessesProductsReport1',
      {
        requestID: requestID(),
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching vendor businesses:', error);
    throw error;
  }
};

export const getVendorPaymentSummaryReport = async (vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getVendorPaymentSummaryReport1',
      {
        requestID: requestID(),
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching payment summary:', error);
    throw error;
  }
};

export const getVendorPaymentLedgerReport = async (vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getVendorPaymentLedgerReport1',
      {
        requestID: requestID(),
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching payment ledger:', error);
    throw error;
  }
};

export const approveVendorBusiness = async (businessId: string, status: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/approveVendorBusiness',
      {
        requestID: requestID(),
        vbusiness_id: businessId,
        status: status
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error approving vendor business:', error);
    throw error;
  }
};

export const disableVendorBusiness = async (businessId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/disableVendorBusiness',
      {
        requestID: requestID(),
        vbusiness_id: businessId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error disabling vendor business:', error);
    throw error;
  }
};

// Get vendor voucher totals
export const getVendorVoucherTotals = async (vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getVendorVoucherTotals',
      {
        requestID: requestID(),
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching vendor voucher totals:', error);
    throw error;
  }
};


// START DONOR REPORT

export const getAllDonorsReport = async () => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getAllDonorsReport1',
      {
        requestID: requestID()
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching vendors:', error);
    throw error;
  }
};


export const getDonorCampaignsReport = async (campaignId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getCampaignsVendorsReport1',
      {
        requestID: requestID(),
        campaign_id: campaignId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching vendors report:', error);
    throw error;
  }
};


export const getPaymentLedgerReport_comm = async (vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getPaymentLedgerReport_comm',
      {
        requestID: requestID(),
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching payment ledger:', error);
    throw error;
  }
};

export const getDonorPaymentLedgerReport = async (vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getVendorPaymentLedgerReport1',
      {
        requestID: requestID(),
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching payment ledger:', error);
    throw error;
  }
};

export const getDonorPaymentSummaryReport = async (vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getDonorCampaignSummaryReport',
      {
        requestID: requestID(),
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching payment summary:', error);
    throw error;
  }
};

export const getDonorVoucherTotals = async (vendorId: string) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getVendorVoucherTotals',
      {
        requestID: requestID(),
        vendor_id: vendorId
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching vendor voucher totals:', error);
    throw error;
  }
};

export const createCommission = async (commissionPercent) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/createCommission',
      {
        requestID: requestID(),
        commission_percent: commissionPercent
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error creating commission:', error);
    throw error;
  }
};

export const getCommission = async () => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/getCommission',
      {
        requestID: requestID()
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching commission:', error);
    throw error;
  }
};

export const updateCommission = async (commissionId, commissionPercent) => {
  try {
    const response = await axios.post(
      baseUrl3() + 'campaigns/updateCommission',
      {
        requestID: requestID(),
        commission_id: commissionId,
        commission_percent: commissionPercent
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error updating commission:', error);
    throw error;
  }
};